import { apiConfig, client } from '@/api';
import { OauthApi } from '@/api/generated/MNT/apis/oauth-api';
import { config } from '@/config';

export const oauthApi = new OauthApi(apiConfig, config.API_URL, client);
